import LawsuitByCustomerOverTimeColumnChart from "./LawsuitByCustomerOverTimeColumnChart";

export default LawsuitByCustomerOverTimeColumnChart;
